import $ from 'jquery'
import Rellax from 'rellax';

export const ParallaxBg = (() => {
  'use strict'

  function init() {

		if( $('.bg-pattern').length > 0 ) {
			var rellax = new Rellax('.bg-pattern', {
				speed: -6,
			});
		}

  }
  return { init }
})()
